import { render, staticRenderFns } from "./FactorTable.vue?vue&type=template&id=6e25ded5"
import script from "./FactorTable.vue?vue&type=script&lang=js"
export * from "./FactorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports